import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { getFCMWebTokenAndHandleNotifications } from '../firebase-config';
import { updateSelectedAppontemnt } from '../store/appointmentSlice';

const useFirebaseNotifications = () => {
  const dispatch = useDispatch();

  const handleNotification = (remoteMessage) => {
    console.log('App Message received. ', remoteMessage);
    const { notification } = remoteMessage;
    // Notification type
    const notificationType = remoteMessage?.data?.notificationType ?? 'default';

    // handle Notification for patient count here
    if (
      notificationType === 'PATIENT_COUNTER_UPDATE_NOTIFICATION' ||
      notificationType === 'Patient Counter Update Notification'
    ) {
      dispatch(updateSelectedAppontemnt(remoteMessage?.data?.counter));
    }

    // handle Notification for twillio message
    const audio = new Audio('../sounds/message_tone.mp3'); // Add a ringtone file to the public folder
    audio.play().catch((error) => {
      console.error('Audio playback failed:', error);
    });
   // toast(JSON.stringify(notification?.title));
  };

  useEffect(() => {
    getFCMWebTokenAndHandleNotifications(handleNotification);
  }, [dispatch]);
};

export default useFirebaseNotifications;
